// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__WwBfR","col":"styles_col__JKzdK","fulfillmentStatus":"styles_fulfillmentStatus__3vZQ5","emailCol":"styles_emailCol__R_weO"};